import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace',
    standalone: false
})
export class ReplacePipe implements PipeTransform {
  transform(value: string, pattern: string, replacement: string): string {
    return value ? value.replace(new RegExp(pattern, 'g'), replacement) : '';
  }
}
